/** 修改手机号模态窗 */
import * as React from 'react';
import { Button, Form, Row, message, Col, Steps, Input } from 'antd';
import I18N from 'src/services/I18NService';
import WalletService, {
  EAccountMemberType,
  EEnterpriseRegisterStep,
  ERegisterStep,
  IAccountInfo, IUnbindMobileParam,
} from 'src/services/WalletService';
import '../views/Wallet/wallet.css';
import { FormComponentProps, FormItemProps } from 'antd/lib/form';

import { IAgentInfo } from 'src/entity/AgentEntity';
import { IDrugStoreInfo } from 'src/entity/DrugStoreEntity';
import TencentCaptchaButton from './TencentCaptchaButton';
import { IVerificationCode } from 'src/entity/LoginParam';

const { Step } = Steps;

interface IFormProps extends FormComponentProps {
  userInfo?: IAgentInfo | IDrugStoreInfo;
  /** 开户账号信息 */
  account: IAccountInfo;
  closeModal(): void;
  mobileChanged(changed: boolean): void;
}

interface IFormState {
  /** 是否正在提交 */
  isLoading: boolean;
  /** 当前步骤 */
  currentStep: number;
}

/**
 * 表单控件绑定数据
 */
interface IFormData {
  /** 账号名 */
  userName: string,
  /** 原手机号 */
  oldPhone: string,
  /** 解绑验证码 */
  unbindCode: string,
  /** 新手机号 */
  newPhone: string;
  /** 绑定验证码 */
  bindCode: string,
}

/**
 * 创建提现Form组件
 */
class CreateModifyMobileForm extends React.Component<IFormProps, IFormState> {
  private walletService = WalletService;
  constructor(props: IFormProps) {
    super(props);
    this.state = { isLoading: false, currentStep: 0};
  }

  /**
   * 解绑手机号确认提交
   */
  mobileUnbindSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    const {
      form,
      account,
    } = this.props;
    const { phone, id, } = account;
    if (!phone || !id) {
      return;
    }
    form.validateFields(['unbindCode'], async (err, values: IFormData) => {
      if (!err) {
        const {
          unbindCode
        } = values;
        const params: IUnbindMobileParam = {
          verification_code: unbindCode,
          phone,
        };
        this.setState({isLoading: true});
        const res = await this.walletService.unbindMobile(id, params);
        this.setState({isLoading: false});
        if (res) {
          message.success('手机号解绑成功');
          this.setState({currentStep: 1});
          this.props.mobileChanged(true);
        }
      }
    });
  };

  /**
   * 绑定手机号确认提交
   */
  mobileBindSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    const {
      form,
      account,
      closeModal,
    } = this.props;
    const { member_type } = account;
    form.validateFields(['newPhone', 'bindCode'], async (err, values: IFormData) => {
      if (!err) {
        const {
          bindCode,
          newPhone
        } = values;
        const params = {
          verification_code: bindCode,
          phone: newPhone,
          step: member_type === EAccountMemberType.Individual ? ERegisterStep.Phone : EEnterpriseRegisterStep.Phone,
          member_type,
        };
        this.setState({isLoading: true});
        let isSucceed = false;
        try {
          isSucceed = await this.walletService.registerPhone(params);
          if (isSucceed) {
            message.success('手机号修改成功');
          } else {
            message.error('手机号修改失败');
          }
        } catch (error) {
          this.walletService.handleError(error);
        }
        this.setState({isLoading: false});
        if (isSucceed) {
          this.props.mobileChanged(true);
          closeModal();
        }
      }
    });
  };

  /**
   * 获取解绑原手机号验证码
   * @param data 
   */
   verifyMobileUnbindCode = async () => {
    const { account } = this.props;
    const { member_type, phone } = account;
    let isSucceed = false;
    if (!!phone) {
      try {
        const res = await this.walletService.verifyCode(phone, member_type, 6);
        if (res) {
          isSucceed = true;
          message.success('发送成功');
        }
      } catch (error) {
        console.error('verifyMobileUnbindCode failed: ', error);
      }
      if (!isSucceed) {
        message.error('发送失败');
      }
    } else {
      message.error('账户手机号为空');
    }
  }

  /**
   * 获取绑定原手机号验证码
   * @param data 
   */
   verifyMobileBindCode = async (data: IVerificationCode) => {
    const { account } = this.props;
    const { member_type } = account;
    const { mobile } = data;
    let isSucceed = false;
    if (!!mobile) {
      try {
        const res = await this.walletService.verifyCode(mobile, member_type);
        if (res) {
          isSucceed = true;
          message.success('发送成功');
        }
      } catch (error) {
        console.error('verifyMobileUnbindCode failed: ', error);
      }
      if (!isSucceed) {
        message.error('发送失败');
      }
    } else {
      message.error('账户手机号为空');
    }
  }

  render() {
    const formItemLayout: FormItemProps = {
      labelCol: { span: 7 },
      wrapperCol: { span: 15 },
    };
    const { form, account, userInfo, closeModal } = this.props;
    const { isLoading, currentStep } = this.state;
    const { getFieldDecorator } = form;
    let userName = '';
    const oldMobile = account.phone || '';
    if (!!userInfo) {
      userName = userInfo.admin_username || '';
    }

    return (
      <Form>
        <Steps type="navigation" current={currentStep}>
          <Step title="解绑旧手机" />
          <Step title="绑定新手机" />
        </Steps>
        <div style={{marginTop: 24}}>
          {currentStep === 0 && (
            <React.Fragment>
              <Form.Item label={'账号名'} {...formItemLayout} key={'userName'}>
                {getFieldDecorator('userName', {
                  initialValue: userName,
                })(
                  <Input disabled={true} />
              )}
              </Form.Item>
              <Form.Item label={'原手机号'} {...formItemLayout} key={'oldPhone'}>
                {getFieldDecorator('oldPhone', {
                  initialValue: oldMobile,
                })(
                  <Input disabled={true} />
              )}
              </Form.Item>
              <Form.Item label={'验证码'} {...formItemLayout} key={'unbindCode'}>
                {getFieldDecorator('unbindCode', {
                  rules: [{ required: true, message: `${I18N.get('common_input')}${I18N.get('login_verify_code')}` }]
                })(
                  <Input
                    placeholder={`${I18N.get('common_input')}${I18N.get('login_verify_code')}`}
                    suffix={
                    <TencentCaptchaButton
                      isDomestic={true}
                      phoneOrEmail={oldMobile || ''}
                      onSend={() => this.verifyMobileUnbindCode()}
                    />
                  }/>
              )}
              </Form.Item>
              <Row gutter={24} style={{ margin: 0 }}>
                <Form.Item style={{ textAlign: 'center', margin: 0 }}>
                  <Button  onClick={closeModal}>
                    {I18N.get('common_cancel')}
                  </Button>
                  <Button style={{marginLeft: 16}} type="primary" loading={isLoading} onClick={this.mobileUnbindSubmit}>
                    下一步
                  </Button>
                </Form.Item>
              </Row>
            </React.Fragment>
          )}
        {currentStep === 1 && (
          <React.Fragment>
            <Form.Item label={'新手机号'} {...formItemLayout} key={'newPhone'}>
              {getFieldDecorator('newPhone', {
                rules: [
                  { required: true,
                    message: `${I18N.get('common_input')}${I18N.get('common_mobile')}`
                  },
                  {
                    pattern: /^((13)|(14)|(15)|(16)|(17)|(18)|(19))\d{9}$/,
                    message: `${I18N.get('err_mobile')}`,
                  },
                ]
              })(
                <Input placeholder={`${I18N.get('common_input')}${I18N.get('common_mobile')}`}/>
            )}
            </Form.Item>
            <Form.Item label={'验证码'} {...formItemLayout} key={'bindCode'}>
              {getFieldDecorator('bindCode', {
                rules: [
                  {
                    required: true,
                    message: `${I18N.get('common_input')}${I18N.get('login_verify_code')}` },
                ]
              })(
                <Input
                  placeholder={`${I18N.get('common_input')}${I18N.get('login_verify_code')}`}
                  suffix={
                  <TencentCaptchaButton
                    isDomestic={true}
                    phoneOrEmail={this.props.form.getFieldValue(`newPhone`)}
                    onSend={(data) => this.verifyMobileBindCode(data)}
                  />
                }/>
            )}
            </Form.Item>
            <Row gutter={24} style={{ margin: 0 }}>
                <Form.Item style={{ textAlign: 'center', margin: 0 }}>
                  <Button  onClick={closeModal}>
                    {I18N.get('common_cancel')}
                  </Button>
                  <Button style={{marginLeft: 16}} type="primary" loading={isLoading} onClick={this.mobileBindSubmit}>
                    {I18N.get('common_ok')}
                  </Button>
                </Form.Item>
              </Row>
          </React.Fragment>
        )}
        </div>
      </Form>
    );
  }

 
}
export const ModifyMobileForm = Form.create<IFormProps>()(CreateModifyMobileForm);


// WEBPACK FOOTER //
// ./src/components/common/ModifyMobileForm.tsx